require('./pop.less');

const continer = $('<div class="enhancer-fe-pop"></div>');
$('body').append(continer);

const pop = {
	show(opt) {
		opt = opt || {};
		const option = $.extend(true, {
			mask: true,
			icon: '',
			close: false,
			title: '',
			content: 'content',
			timeout: 2500,
			autoClose: true
		}, opt || {});

		if (!option.footer && !('mask' in opt)) {
			option.mask = false;
		}

		const mask =  option.mask ? '<div class="fe-pop-mask"></div>' : '';
		const close = option.close ? '<div class="fe-pop-close">&times</div>' : '';
		const icon = option.icon ? `<div class="fe-pop-icon pop-${option.icon}"></div>` : '';
		const title = option.title ? `<div class="fe-pop-title">${option.title}</div>` : '';
		const footer = option.footer ? `<div class="fe-pop-footer">
						${Object.keys(option.footer).map((key) => {
							return `<button class="enhancer-btn" data-callback="${key}">${key}</button>`
						})}
					</div>` : '';

		

		const html = `${mask}
			<div class="fe-pop-wrap">
				${close}
				<div class="fe-pop-content-wrap">
					${icon}
					<div>
						${title}
						<div class="fe-pop-content">${option.content}</div>
						${footer}
					</div>
				</div>
			</div>
		`;

		continer.html(html).show();
		continer.off('click');
		continer.on('click', '.fe-pop-close', (e) => {
			pop.hide('close');
		});
		continer.on('click', '.fe-pop-footer button', (e) => {
			const key = $(e.target).data('callback');
			const callbak = option.footer[key];
			if (callbak && typeof callbak === 'function') {
				callbak.call(e.target, e);
				if (option.autoClose) {
					pop.hide(`footer.${key}`);
				}
			}
		});

		if (!option.footer && option.timeout) {
			setTimeout(() => {
				pop.hide('timeout');
			}, option.timeout);
		}
		this.option = option;
	},
	hide(from) {
		continer.hide();
		const onHide = this.option.onHide;

		if (onHide && typeof onHide === 'function') {
			onHide(from);
		}
	}
}

module.exports = pop;



// WEBPACK FOOTER //
// ./~/fe-pop/src/pop.js